import React from 'react';
import { Grid } from 'semantic-ui-react';

export const ChangeBalanceGridHeader = () => {
  return (
    <Grid>
      <Grid.Row columns={6}>
        <Grid.Column width={4} />
        <Grid.Column className="column-header--right" width={3}>
          ORIGINAL
        </Grid.Column>
        <Grid.Column width={1} />
        <Grid.Column className="column-header--right" width={4}>
          ADJUSTMENT
        </Grid.Column>
        <Grid.Column width={1} />
        <Grid.Column className="column-header--right" width={3}>
          NEW
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};



// WEBPACK FOOTER //
// ./src/pages/accountsetup/components/changebalance/ChangeBalanceGridHeader.js